
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import RCSlider from 'rc-slider';
import SliderHandle from './SliderHandle';

import styles from './styles.js';

import { getAverageResultPrice } from '../../../../../selectors';

const createSliderWithTooltip = RCSlider.createSliderWithTooltip;
const Range = createSliderWithTooltip(RCSlider.Range);

const mapStateToProps = state => ({
    averageResultPrice: getAverageResultPrice(state.searchResults),
    currencySymbol: state.searchObject.currency_symbol_left
});

class Slider extends Component {
    static propTypes = {
        averageResultPrice: PropTypes.number.isRequired,
        changeButtonText: PropTypes.func,
        currencySymbol: PropTypes.string.isRequired,
        filter: PropTypes.object.isRequired,
        filterGroupCollectionIndex: PropTypes.number.isRequired,
        filterGroupIndex: PropTypes.number.isRequired,
        filterIndex: PropTypes.number.isRequired,
        handleSliderChange: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired
    }

    state = {
        max: Number(this.props.filter.data.values.find(val => val.slug === 'max_price').value),
        min: Number(this.props.filter.data.values.find(val => val.slug === 'min_price').value)
    }

    drawHistogram = () => {
        const data = google.visualization.arrayToDataTable([
            ['Dinosaur', 'Length'],
            ['Acrocanthosaurus (top-spined lizard)', 12.2],
            ['Albertosaurus (Alberta lizard)', 9.1],
            ['Allosaurus (other lizard)', 12.2],
            ['Apatosaurus (deceptive lizard)', 22.9],
            ['Archaeopteryx (ancient wing)', 0.9],
            ['Argentinosaurus (Argentina lizard)', 36.6],
            ['Baryonyx (heavy claws)', 9.1],
            ['Brachiosaurus (arm lizard)', 30.5],
            ['Ceratosaurus (horned lizard)', 6.1],
            ['Coelophysis (hollow form)', 2.7],
            ['Compsognathus (elegant jaw)', 0.9],
            ['Deinonychus (terrible claw)', 2.7],
            ['Diplodocus (double beam)', 27.1],
            ['Dromicelomimus (emu mimic)', 3.4],
            ['Gallimimus (fowl mimic)', 5.5],
            ['Mamenchisaurus (Mamenchi lizard)', 21.0],
            ['Megalosaurus (big lizard)', 7.9],
            ['Microvenator (small hunter)', 1.2],
            ['Ornithomimus (bird mimic)', 4.6],
            ['Oviraptor (egg robber)', 1.5],
            ['Plateosaurus (flat lizard)', 7.9],
            ['Sauronithoides (narrow-clawed lizard)', 2.0],
            ['Seismosaurus (tremor lizard)', 45.7],
            ['Spinosaurus (spiny lizard)', 12.2],
            ['Supersaurus (super lizard)', 30.5],
            ['Tyrannosaurus (tyrant lizard)', 15.2],
            ['Ultrasaurus (ultra lizard)', 30.5],
            ['Velociraptor (swift robber)', 1.8]
        ]);

        const options = {
            colors: ['#767676'],
            hAxis: {
                baselineColor: 'transparent',
                gridlines: {
                    color: 'transparent'
                }
            },
            legend: {
                position: 'none'
            },
            tooltip: {
                trigger: 'none'
            },
            vAxis: {
                baselineColor: 'transparent',
                gridlines: {
                    color: 'transparent'
                }
            }
        };

        const chart = new google.visualization.Histogram(document.getElementById('historgram'));

        chart.draw(data, options);
    }

    formatTip = value => {
        return `${value}%`;
    }

    handleChange = valueArr => {
        const { filterGroupIndex, filterIndex, handleSliderChange } = this.props;
        handleSliderChange(filterGroupIndex, filterIndex, valueArr);
    }

    handleInstantChange = valueArr => {
        this.setState({ max: valueArr[1], min: valueArr[0] });
    }

    render() {
        const { formatTip, handleChange, handleInstantChange } = this;
        const { currencySymbol, filter } = this.props;
        const { max, min } = this.state;
        return (
            <div>
                <div style={{ marginBottom: '5px' }}>
                    <div style={{ marginBottom: '8px' }}>
                        <div className={css(styles.textRegular)}>
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: currencySymbol }} />{min}
                            </span>
                            <span>
                                {' - '}
                            </span>
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: currencySymbol }} />{max}
                            </span>
                        </div>
                    </div>
                </div>
                <div id="historgram" />
                <div
                    style={{
                        width: '100%',
                        padding: '0px 11px 0 5px'
                    }}
                >
                    <Range
                        handle={SliderHandle}
                        defaultValue={[min, max]}
                        max={Number(filter.data.defaults.find(def => def.slug === 'max_price').value)}
                        min={Number(filter.data.defaults.find(def => def.slug === 'min_price').value)}
                        tipFormatter={formatTip}
                        onAfterChange={handleChange}
                        onChange={handleInstantChange}
                    />
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Slider);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Slider/Slider.jsx